// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSQ6ioR9uEoz8ZzxSf2q{align-items:center;min-height:40px;padding:8px 12px 8px 8px}.CSQ6ioR9uEoz8ZzxSf2q.MjfiOYdwDMobwwYBSP5j{padding-left:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectMembersPadding": `CSQ6ioR9uEoz8ZzxSf2q`,
	"empty": `MjfiOYdwDMobwwYBSP5j`
};
export default ___CSS_LOADER_EXPORT___;
